// @ngInject
function TimedOutLoginDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(username, expireDate) {

        var modalDefaults = {
            backdrop: false,
            keyboard: false,
            controller: 'TimedOutLoginDialogController as vm',
            templateUrl: 'main/timedOutLoginDialog/timedOutLoginDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            username: function() {
                return username;
            },
            expireDate: function() {
                return expireDate;
            },
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function TimedOutLoginDialogController($uibModalInstance, $translate, ToasterService, loadSpinnerService, $interval, $scope, username, expireDate, AuthService) {
    var vm = this;

    vm.state = 0; // State 0 = Keep session?, State 1 = Are you sure?, State 2 = Refresh error!, State 3 = Refresh success!, State 4 = Hidden
    vm.password = "";
    vm.username = username;
    vm.timer = {
        expireDate: expireDate,
        minutes: 0,
        seconds: 0,
        displayValue: '5:00'
    }
    vm.errorMessage = '';
    vm.refreshSuccess = false;
    vm.successCountDownTimer = 5;
    var timerIntervalPromise;

    vm.closeModal = closeModal;
    vm.refreshSession = refreshSession;

    recalculateTimer();
    activate();

    function activate()
    {
        loadSpinnerService.start('mainSpinner');
        timerIntervalPromise = $interval(recalculateTimer, 1000);
    }

    function recalculateTimer(){
        var timeLeft = Date.parse(vm.timer.expireDate)-Date.parse(new Date());

        if(timeLeft <= 0)
        {
            location.reload();
            return;
        }

        vm.timer.minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        vm.timer.seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        vm.timer.displayValue = vm.timer.minutes + ':';

        if(vm.timer.seconds < 10)
            vm.timer.displayValue += '0' + vm.timer.seconds.toString();
        else
            vm.timer.displayValue += vm.timer.seconds.toString();
    }
    
    function SuccessCountDownCloseModal(){
        vm.successCountDownTimer--;
        if(vm.successCountDownTimer === 0){
            closeModal()
        }
    }

    function closeModal() {
        loadSpinnerService.stop('mainSpinner', {force: true});
        $interval.cancel(timerIntervalPromise);
        $uibModalInstance.close(vm.refreshSuccess);
    }

    function refreshSession(){
        vm.state = 4;
        AuthService.refreshSession(function(success, errorMessage){

            if(success){
                vm.state = 3;
                vm.refreshSuccess = success;
                ToasterService.showSuccess($translate.instant('login.refreshsession.success'), $translate.instant('common.done'), 10000);
                $interval.cancel(timerIntervalPromise);
                //To automaticlly close modal after 5 seconds.
                timerIntervalPromise = $interval(SuccessCountDownCloseModal, 1000);
            }else {
                vm.state = 2;
                vm.errorMessage = errorMessage;
            }
            
        });
    }
}

angular
    .module('timedOutLoginDialog.timedOutLoginDialog', [])
    .service('TimedOutLoginDialogService', TimedOutLoginDialogService)
    .controller('TimedOutLoginDialogController', TimedOutLoginDialogController);